// Escape plain text for insertion into HTML text content or a double-quoted attribute.
export const escapeHtml = text => String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')

// Escape plain text and wrap every match of the (global) regex in <mark>.
export const highlightHtml = (text, re) => {
    const str = String(text ?? '')
    let html = ''
    let last = 0

    for (const match of str.matchAll(re)) {
        if (!match[0].length) continue
        html += escapeHtml(str.slice(last, match.index)) + '<mark>' + escapeHtml(match[0]) + '</mark>'
        last = match.index + match[0].length
    }

    return html + escapeHtml(str.slice(last))
}
